module.exports = __webpack_public_path__ + "img/slider_a03.86a715b.ce945262.png";